import RibInfo from './RibInfo'

const TodoListeArrivee = () => {
  return (
    <div className='overflow-hidden'>
      <h3 className="text-md font-semibold mb-2">To Do list pour votre arrivée :</h3>
      <div className="w-full bg-primary-100 p-4 rounded-none space-y-4">
        <div>
          <h5 className="font-semibold mb-2">Régler votre entrée</h5>
          <p className="text-sm text-gray-600">
            Les montants pour votre arrivée sont à payer un par un sur le compte d'agence (un montant = un virement). En cas de non-réception des paiements au plus tard la veille de l'état des lieux, le rendez-vous d'état des lieux ne pourra être maintenu.
          </p>
          <RibInfo />
        </div>
        <div>
          <h5 className="font-semibold mb-2">Assurance habitation</h5>
          <p className="text-sm text-gray-600">
            Ouvrir votre contrat et en fournir une copie à l'agence.
          </p>
        </div>
        <div>
          <h5 className="font-semibold mb-2">Contrats d'énergie</h5>
          <p className="text-sm text-gray-600">
            Ouvrir vos contrats gaz et/ou électricité pour le jour J au plus tard.
          </p>
        </div>
      </div>
    </div>
  )
}

export default TodoListeArrivee